import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { payments as paymentsApi } from "../services/api";

export default function BookingSuccessPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const bookingId = searchParams.get("booking_id");

  useEffect(() => {
    if (!bookingId) { setStatus("error"); return; }

    // 稍等一下讓 Stripe Webhook 處理完
    setTimeout(() => {
      paymentsApi.getStatus(bookingId)
        .then(data => setStatus(data.status === "paid" ? "success" : "pending"))
        .catch(() => setStatus("success")); // webhook 可能還沒到，先顯示成功
    }, 2000);
  }, [bookingId]);

  return (
    <div style={{
      minHeight: "calc(100vh - 60px)",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: 24,
    }}>
      <div className="card fade-up" style={{ width: "100%", maxWidth: 420, padding: 48, textAlign: "center" }}>

        {status === "loading" && (
          <>
            <span className="spinner" style={{ margin: "0 auto 24px" }} />
            <p style={{ color: "var(--muted)" }}>確認付款中...</p>
          </>
        )}

        {(status === "success" || status === "pending") && (
          <>
            <div style={{ fontSize: 56, marginBottom: 24 }}>🎉</div>
            <h1 style={{ fontSize: 28, marginBottom: 12 }}>付款成功！</h1>
            <p style={{ color: "var(--muted)", marginBottom: 8 }}>
              你的課程已確認，確認信將寄送至你的信箱。
            </p>
            <p style={{ color: "var(--muted)", fontSize: 13, marginBottom: 32 }}>
              預約編號：#{bookingId}
            </p>
            <button
              className="btn btn-primary btn-full"
              style={{ height: 48 }}
              onClick={() => navigate("/bookings")}
            >
              查看我的預約
            </button>
          </>
        )}

        {status === "error" && (
          <>
            <div style={{ fontSize: 56, marginBottom: 24 }}>❌</div>
            <h1 style={{ fontSize: 28, marginBottom: 12 }}>發生錯誤</h1>
            <p style={{ color: "var(--muted)", marginBottom: 32 }}>找不到付款資訊</p>
            <button className="btn btn-outline btn-full" onClick={() => navigate("/bookings")}>
              回到我的預約
            </button>
          </>
        )}

      </div>
    </div>
  );
}
